import React, {useContext, useState, useEffect} from "react";
import Api from "../../../Api";
import {useParams} from "react-router-dom";
import {withAuth} from "../../../hoc/Auth";
import {Column, Container, Wrapper} from "../../../hoc/Layout";
import {InputHelper, MaskedIH, Select, AddressDaData} from "../../../Components/Utils/FieldsHelper";
import SingleDatePicker from "../../../Components/Utils/SingleDatePicker";
import EmptyCard from "../../../hoc/EmptyCard";
import Button from "../../../Components/Utils/UI/Button";
import MessageContext from "../../../MessageContext";

import classes from "./styles.module.css";
import Modal from "../../../Components/Utils/Modal";
import { useHistory } from "react-router-dom";

function ContractEdit({token}) {
    const history = useHistory()
    const {onMessage} = useContext(MessageContext);

    const [contractID] = useState(useParams().ID)
    const [contract, setContract] = useState(null)
    const [viewMode, setViewMode] = useState(false)

    const [form, setForm] = useState({
        id: null,
        name: "",
        date: "",
        passportSeries: "",
        passportNumber: "",
        passportIssuedBy: "",
        passportIssuedAt: "",
        passportIssuedByCode: "",
        lastName: "",
        firstName: "",
        patronymic: "",
        gender: null,
        birthDate: "",
        birthPlace: "",
        birthCountryCode: "",
        phone: "",
        inn: "",
        addressFact: {value: ""},
        addressRegistered: {value: ""},
        merchant: null
    });

    const [deleteModalActive, setIsDeleteModalActive] = useState(false)

    const [isRequest, setIsRequest] = useState(false);
    const [projects, setProjects] = useState([]);

    const genderList = [
        {displayName: 'Мужской', isEnabled: true, id: "0"},
        {displayName: 'Женский', isEnabled: true, id: "1"}
    ];

    const countryList = [
        {displayName: 'Россия', isEnabled: true, id: 'Россия'},
    ]

    useEffect(() => {
        setIsRequest(true)
        new Api({token}).getMetalContract(contractID).then((data) => {
            setContract(data.data)
            setForm({
                id: data.data.id,
                name: data.data.name,
                date: new Date(Date.parse(data.data.date)),
                passportSeries: data.data.passportSeries,
                passportNumber: data.data.passportNumber,
                passportIssuedBy: data.data.passportIssuedBy,
                passportIssuedAt: new Date(Date.parse(data.data.passportIssuedAt)),
                passportIssuedByCode: data.data.passportIssuedByCode,
                lastName: data.data.lastName,
                firstName: data.data.firstName,
                patronymic: data.data.patronymic,
                gender: {"displayName": data.data.gender},
                birthDate: new Date(Date.parse(data.data.birthDate)),
                birthPlace: data.data.birthPlace,
                birthCountryCode: {"displayName": data.data.birthCountry.name},
                phone: data.data.phone,
                inn: data.data.inn,
                addressFact: {"value" : data.data.addressFact},
                addressRegistered: {"value": data.data.addressRegistered},
                merchant: {"displayName": data.data.merchantId}
            })
            setIsRequest(false)
        })

        new Api({token}).getProjects().then((res) => {
            setProjects(res);
        })
    }, []);

    function handleChange(name, value) {
        setForm({...form, [name]: value});
    }

    function handleDelete(){
        new Api({token}).deleteMetalContract(form.id).then(r => {
            if (r.status === 200 || r.status === 201 || r.status === 204) {
                setIsDeleteModalActive(false)
                setViewMode(true)
                onMessage({type: 'success', message: 'Контракт успешно удалён!'});
                history.push('/metal')
            } else {
                onMessage({type: "error", message: "Ошибка"})
            }
        }).finally(() => {
            setIsRequest(false)
        })
    }

    function handleActivate() {

        setIsRequest(true);

        for (let key in form) {
            if (form[key] === null || form[key].length === 0) {
                onMessage({type: 'warning', message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.'});
                return setIsRequest(false);
            }
        }
        const formClone = {
            name: form.name,
            date: form.date.toISOString().split('T')[0],
            passportSeries: form.passportSeries,
            passportNumber: form.passportNumber,
            passportIssuedBy: form.passportIssuedBy,
            passportIssuedAt: form.passportIssuedAt.toISOString().split('T')[0],
            passportIssuedByCode: form.passportIssuedByCode,
            phone: form.phone,
            inn: form.inn,
            addressRegistered: form.addressRegistered.value,
            addressFact: form.addressFact.value,
            firstName: form.firstName,
            lastName: form.lastName,
            patronymic: form.patronymic,
            gender: form.gender.displayName,
            birthCountryCode: 643,
            birthDate: form.birthDate.toISOString().split('T')[0],
            birthPlace: form.birthPlace,
            merchantId: form.merchant.id,

        }
        new Api({token}).updateMetalContract(form.id, formClone).then(r => {
            if (r.status === 200 || r.status === 201) {
                onMessage({type: 'success', message: 'Контракт успешно обновлён! Можете покинуть данную страницу'});
            } else {
                onMessage({type: "error", message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова."})
            }
        }).finally(() => {
            setIsRequest(false);
        })
    }

    return (
        <Wrapper>
            <Container style={{justifyContent: 'center'}}>
                <Column width={'100%'}>
                    <EmptyCard title={"FieldsHelper.label.contractEdit"}>

                        <div className={classes.Content}>
                            <div className={classes.Column}>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={handleChange}
                                            value={form.name}
                                            placeholder={"SAMPLE_01"}
                                            fieldName={"name"}
                                            label={"FieldsHelper.label.ContractName"}
                                            changeRegexp={/[^A-Za-zА-Яа-я0-9\-\s"_№]+/g}
                                            blurRegexp={/^[A-Za-zА-Яа-я0-9\-\s"_№]/}
                                            changeMessage={"FieldsHelper.label.ContractName"}
                                            blurMessage={"FieldsHelper.label.ContractName"}
                                            isDisabled={isRequest || viewMode}
                                            isRequired
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>Дата контракта</label>

                                        <SingleDatePicker
                                            selected={form.date}
                                            onChange={date => {
                                                setForm({...form, date: date});
                                            }}
                                            className={classes.Input}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="0000-00-00"
                                            disabled={isRequest || viewMode}
                                        />
                                    </div>
                                </div>
                                <div className={classes.InputWrap}>
                                    <Select
                                        label={"FieldsHelper.label.project"}
                                        placeholder={"FieldsHelper.label.project"}
                                        values={projects}
                                        onChange={(value) => handleChange("merchant", value)}
                                        selectedValue={form.merchant}
                                        fieldName={"displayName"}
                                        fieldStatus={"status"}
                                        isLoading={true}
                                    />
                                </div>

                                <h3 className={classes.Title}>Паспортные данные</h3>

                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            fieldName={"passportSeries"}
                                            value={form.passportSeries}
                                            label={"FieldsHelper.label.docSerial"}
                                            blurMessage={"FieldsHelper.error.docSerial"}
                                            placeholder={"00 00"}
                                            mask={[/\d/, /\d/, " ", /\d/, /\d/]}
                                            isDisabled={isRequest || viewMode}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            fieldName={"passportNumber"}
                                            value={form.passportNumber}
                                            label={"FieldsHelper.label.docNumber"}
                                            blurMessage={"FieldsHelper.error.docNumber"}
                                            placeholder={"000000"}
                                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                            isDisabled={isRequest || viewMode}
                                        />
                                    </div>
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.passportIssuedBy}
                                        placeholder={"Например: Отделом внутренних дел Г. МОСКВЫ"}
                                        fieldName={"passportIssuedBy"}
                                        label={"FieldsHelper.label.Issued"}
                                        changeRegexp={/[^А-Яа-я\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={isRequest || viewMode}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>

                                        <label className={classes.Label}>Дата выдачи</label>

                                        <SingleDatePicker
                                            selected={form.passportIssuedAt}
                                            onChange={date => {
                                                setForm({...form, passportIssuedAt: date});
                                            }}
                                            className={classes.Input}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="0000-00-00"
                                            disabled={isRequest || viewMode}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            value={form.passportIssuedByCode}
                                            fieldName={"passportIssuedByCode"}
                                            label={"FieldsHelper.label.departmentCode"}
                                            blurMessage={"FieldsHelper.error.docIssuerCode"}
                                            placeholder={"000-000"}
                                            mask={[/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
                                            isDisabled={isRequest || viewMode}
                                        />
                                    </div>
                                </div>

                                <h3 className={classes.Title}>Личные данные</h3>

                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.lastName}
                                        placeholder={"Например: Курчатов"}
                                        fieldName={"lastName"}
                                        label={"FieldsHelper.label.lastName"}
                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                        changeMessage={"FieldsHelper.error.onlyLettersLastName"}
                                        blurMessage={"FieldsHelper.error.onlyLettersLastName"}
                                        isDisabled={isRequest || viewMode}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.firstName}
                                        placeholder={"Например: Игорь"}
                                        fieldName={"firstName"}
                                        label={"FieldsHelper.label.firstName"}
                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                        changeMessage={"FieldsHelper.error.onlyLettersFirstName"}
                                        blurMessage={"FieldsHelper.error.onlyLettersFirstName"}
                                        isDisabled={isRequest || viewMode}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.patronymic}
                                        placeholder={"Например: Васильевич"}
                                        fieldName={"patronymic"}
                                        label={"FieldsHelper.label.patronymic"}
                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                        changeMessage={"FieldsHelper.error.onlyLettersPatronymic"}
                                        blurMessage={"FieldsHelper.error.onlyLettersPatronymic"}
                                        isDisabled={isRequest || viewMode}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <Select
                                            label={"FieldsHelper.label.gender"}
                                            placeholder={"FieldsHelper.placeholder.gender"}
                                            values={genderList}
                                            onChange={(value) => handleChange("gender", value)}
                                            selectedValue={form.gender}
                                            fieldName={"displayName"}
                                            fieldStatus={"isEnabled"}
                                            isLoading={isRequest || viewMode}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>Дата рождения</label>

                                        <SingleDatePicker
                                            selected={form.birthDate}
                                            onChange={date => {
                                                setForm({...form, birthDate: date});
                                            }}
                                            className={classes.Input}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="0000-00-00"
                                            disabled={isRequest || viewMode}
                                        />
                                    </div>
                                </div>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={handleChange}
                                            value={form.birthPlace}
                                            placeholder={""}
                                            fieldName={"birthPlace"}
                                            label={"FieldsHelper.label.birthPlace"}
                                            changeRegexp={/[^A-Za-zА-Яа-я\s".]+/g}
                                            blurRegexp={/^[A-Za-zА-Яа-я\s".]/}
                                            changeMessage={"FieldsHelper.error.onlyLatinBirthPlace"}
                                            blurMessage={"FieldsHelper.error.checkBirthPlace"}
                                            isDisabled={isRequest || viewMode}
                                            isRequired
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <Select
                                            label={"FieldsHelper.label.birthCountry"}
                                            placeholder={"FieldsHelper.placeholder.birthCountry"}
                                            values={countryList}
                                            onChange={(value) => handleChange("birthCountryCode", value)}
                                            selectedValue={form.birthCountryCode}
                                            fieldName={"displayName"}
                                            fieldStatus={"isEnabled"}
                                            isLoading={isRequest || viewMode}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={classes.Column}>

                                <h3 className={classes.Title}>Контактная информация</h3>

                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            value={form.phone}
                                            fieldName={"phone"}
                                            label={"FieldsHelper.label.phone"}
                                            changeMessage={"FieldsHelper.error.onlyNumbersPhone"}
                                            blurMessage={"FieldsHelper.error.checkPhone"}
                                            placeholder={"+7 (917) 574-4444"}
                                            mask={['+', '7', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                            isDisabled={isRequest || viewMode}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={handleChange}
                                            value={form.inn}
                                            fieldName={"inn"}
                                            label={"FieldsHelper.label.inn"}
                                            placeholder={"0000000000"}
                                            changeRegexp={/[^0-9]+/g}
                                            blurRegexp={/^[0-9]{12}/}
                                            changeMessage={"FieldsHelper.error.onlyNumbersInn"}
                                            blurMessage={"FieldsHelper.error.checkNumbersInn"}
                                            isDisabled={isRequest || viewMode}
                                        />
                                    </div>
                                </div>

                                <div className={classes.InputWrap}>
                                    <AddressDaData
                                        onChange={handleChange}
                                        label={"FieldsHelper.label.legalAddress"}
                                        placeholder={"Начните вводить адрес"}
                                        value={form.addressRegistered.value}
                                        fieldName={"addressRegistered"}
                                        changeRegexp={/[^А-Яа-я0-9\s.,]+/g}
                                        blurRegexp={/^[А-Яа-я0-9\s.,]+$/g}
                                        changeMessage={"FieldsHelper.error.onlyLettersAddress"}
                                        isDisabled={isRequest || viewMode}
                                    />
                                </div>

                                <div className={classes.InputWrap}>

                                    <AddressDaData
                                        onChange={handleChange}
                                        label={"FieldsHelper.label.residenceAddress"}
                                        placeholder={"Начните вводить адрес"}
                                        value={form.addressFact.value}
                                        fieldName={"addressFact"}
                                        changeRegexp={/[^А-Яа-я0-9\s.,]+/g}
                                        blurRegexp={/^[А-Яа-я0-9\s.,]+$/g}
                                        changeMessage={"FieldsHelper.error.onlyLettersAddress"}
                                        blurMessage={"FieldsHelper.error.onlyLettersAddress"}
                                        isDisabled={isRequest || viewMode}
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <Button label={"FieldsHelper.label.contractSave"} color={"#4caf50"}
                                            onClick={handleActivate} icon={"checkmark"} isDisabled={viewMode}
                                            isLoading={isRequest}/>
                                </div>
                                {/* <div className={classes.InputWrap}>
                                    <Button label={"FieldsHelper.label.contractBtnCreatePdf"} color={"#3a80c2"}
                                            onClick={handleActivate} icon={"checkmark"} isLoading={isRequest}/>
                                </div> */}
                                <div className={classes.InputWrap}>
                                    <Button
                                        label={"FieldsHelper.label.contractDelete"}
                                        color={"#c23a3aff"}
                                        onClick={() => setIsDeleteModalActive(prev => !prev)}
                                        icon={"checkmark"}
                                        isDisabled={viewMode || !contract || contract.psaProcessingCount > 0}
                                        isLoading={isRequest}
                                    />
                                </div>
                                <Modal
                                    onConfirm={handleDelete}
                                    onClose={() => setIsDeleteModalActive(false)}
                                    isConfirm
                                    isOpen={deleteModalActive}
                                    title="Подтверждение удаления"
                                >
                                    <div>Вы уверены, что хотите удалить выбранный контракт?</div>
                                </Modal>
                            </div>
                        </div>

                    </EmptyCard>
                </Column>
            </Container>
        </Wrapper>
    )
}

export default withAuth(ContractEdit);



// WEBPACK FOOTER //
// ./src/PagesOfUser/Metal/ContractEdit/index.js